<template>
  <div class="configurator-product-list-virtual">
    <RecycleScroller
      v-slot="{ item: { products, id }, index }"
      :items="chunkList"
      :item-size="118"
      :key-field="'id'"
    >
      <div
        :id="`configurator-product-list-virtual--${id}`"
        class="configurator-product-list-virtual__row"
      >
        <ConfiguratorProductItem
          v-for="(item, itemIndex) in products"
          :key="item.product.id"
          v-model="activeProductId"
          class="configurator-product-list-virtual__row-item"
          :img-url="item.configuration.image || item.product.image"
          :label="item.product.name"
          :value="item.product.id"
          :size-id="item.productVariant.sizeId"
          name="product"
          @change="onProductItemChange(index, itemIndex)"
        />
      </div>
    </RecycleScroller>
  </div>
</template>

<script>
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import { RecycleScroller } from 'vue-virtual-scroller';
import ConfiguratorProductItem from './ConfiguratorProductItem';
import {
  ConfiguratorAction,
  ConfiguratorMutation,
  prefixType as prefixConfiguratorType,
} from '../../store/modules/configurator';
import { Breakpoint } from '../../utils/breakpoints';
import { ThemeType } from '../../api/static/ThemeType';

export default {
  name: 'ConfiguratorProductListVirtual',
  components: { ConfiguratorProductItem, RecycleScroller },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    themeType: {
      type: String,
      default: undefined,
      validator: v => v === undefined || Object.values(ThemeType).includes(v),
    },
  },
  computed: {
    itemsPerRow() {
      let itemsPerRow = 4;

      if (this.$matchMedia[Breakpoint.XL]) {
        itemsPerRow = 4;
      } else if (this.$matchMedia[Breakpoint.CONFIGURATOR_L]) {
        itemsPerRow = 3;
      } else if (this.$matchMedia[Breakpoint.M]) {
        itemsPerRow = 4;
      } else if (this.$matchMedia[Breakpoint.XS]) {
        itemsPerRow = 3;
      } else {
        itemsPerRow = 2;
      }

      return itemsPerRow;
    },
    chunkList() {
      const productList = this.items;
      const itemsPerRow = this.itemsPerRow;
      const len = productList.length;
      const chunkList = [];

      for (let i = 0; i < len; i += itemsPerRow) {
        const products = productList.slice(i, i + itemsPerRow);

        chunkList.push({
          id: products.map(item => item.product.id).join('-'),
          products,
        });
      }

      return chunkList;
    },
    activeProductId: {
      get() {
        return this.$store.state.configurator.activeProductId;
      },
      set(productId) {
        this.$store.dispatch(
          prefixConfiguratorType(ConfiguratorAction.SET_ACTIVE_STATE),
          { productId, themeType: this.themeType }
        );
      },
    },
  },
  methods: {
    onProductItemChange(rowIndex, itemIndex) {
      const productIndex = this.itemsPerRow * rowIndex + itemIndex + 1;

      this.$store.commit(
        prefixConfiguratorType(ConfiguratorMutation.SET_SELECTED_PRODUCT_INDEX),
        productIndex
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.configurator-product-list-virtual {
  .vue-recycle-scroller {
    @extend %custom-scrollbar;
    width: 100%;
    height: 100%;
  }

  &__row {
    display: flex;
    gap: 0.5rem;
    justify-content: space-between;
  }

  &__row-item {
    --configurator-product-list-padding: 2.5rem;

    flex: none;
    height: 6.875rem;
    flex-shrink: 1;

    @include map-breakpoint($configurator-product-list-item-width-map)
      using($breakpoint, $value) {
      width: $value;
    }
  }

  ::v-deep .vue-recycle-scroller__item-view {
    padding: 0 1.25rem;
  }
}
</style>
